<template>
  <!-- READ ONLY MODE -->

  <div v-if="mode == 'VIEW'">
    <div class="instruction_info ql-editor pt-0 pl-20" v-html="question.formattedTitle"></div>
    <div class="row p-0 m-0 mt-5">
      <div class="col-md-6 p-2">
        <img width="100%" height="280px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="wong-baker-smiley d-block text-center" alt="hurts-worse.svg" />
        <div class="text-justify pt-8" v-html="question.formattedInformation" />
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="pt-41">
      <div class>
        Step Title
      </div>
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <quill-editor class="bg-white mb-30" v-model="question.formattedTitle" :options="editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer help">Help</h5>
      <quill-editor class="bg-white mt-10 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>

    <div class="pt-14">
      <div class>
        Content
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="instruction-screen bg-white mb-30" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOption"></quill-editor>
      <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30">
        <div class="col-md-11 p-0">
          <h5 class="mt-10">Message</h5>
          <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
        </div>
        <div class="col-md-1 p-0">
          <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
            <img src="static/img/delete.svg" />
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 p-2">
        <img width="100%" height="280px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="wong-baker-smiley d-block text-center" alt="hurts-worse.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepWongBaker",
  mixins: [activityStepCustomMessage],
  components: {
    quillEditor
  },
  props: {
    question: {},
    mode: {
      default: "VIEW"
    },
    commonProps: {},
    activityDetails: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  data() {
    return {
      editorOptionForQuestion: {
        placeholder: "Rate your pain severity.",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      editorOptionForimageCaptureTitle: {
        placeholder: "Enter Title",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      editorOption: {
        placeholder: "Choose the face* that best depicts the pain that you are experiencing.",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      isAddHelpEnabled: false
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    this.init();
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    validateScore(e) {
      if (this.question.score < 0 || this.question.score > 999) {
        this.question.score = Math.abs(e.target.value.slice(0, 3));
        return;
      }
      if (this.question.score == "") {
        this.question.score = 0;
      }
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "score", 0);
        this.$set(this.question, "formattedTitle", "");
        this.$set(this.question, "formattedInformation", "");
      } else {
        this.$set(this.question, "score", this.question.score);
        this.$set(this.question, "formattedTitle", this.question.formattedTitle);
        this.$set(this.question, "formattedInformation", this.question.formattedInformation);
      }
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };

      if (question.formattedTitle && question.formattedInformation) {
        //Validate Title
        const ftitle = this.stripHtml(question.formattedTitle);
        if (ftitle.length > 80) {
          errorObj.isValid = false;
          errorObj.msg = `Step Title cannot exceed 80 limit`;
          return errorObj;
        }
      } else {
        if (this.stripHtml(question.formattedTitle) === "") {
          errorObj.msg = "Step Title is required.";
          errorObj.isValid = false;
          return errorObj;
        }
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      return errorObj;
    },
    scoreUpdate(score) {
      this.$set(this.question, "score", score);
    }
  }
};
</script>

<style scoped lang="scss">
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.wong-baker-smiley {
  margin: 0 auto;
}
.add-help-text {
  right: 493px;
  top: -38px !important;
}
h5.help {
  top: 8px !important;
}
</style>
